import React, { Fragment } from 'react'
import SignUpPage from '../../Components/Auth/SignUpPage'

const SignUp = () => {
    return (
        <Fragment>
            <SignUpPage />
        </Fragment>
    )
}

export default SignUp